import { MIN_SIZE, TRACK_SIZE } from './scroll-container.constants.js';

function computeScrollPosition(
// scrollEl.scrollTop
scrollAmount, 
// scrollEl.scrollHeight
scrollSize, 
// scrollEl.clientHeight
clientSize, 
// consider scrolling to be at the ends within this distance
margin = 0) {
    const scrollRoom = scrollSize - clientSize;
    // When the total overflow is within `margin`, treat it as not scrollable and report 'none'.
    // With the default margin of 0 this collapses to `scrollSize <= clientSize`.
    if (scrollRoom <= margin)
        return 'none';
    if (scrollAmount <= margin)
        return 'start';
    return Math.ceil(scrollAmount) >= scrollRoom - margin ? 'end' : 'middle';
}
/**
 * Thumb size in px. Uses `(client / scroll) * (trackLength - jog)`; `trackLength` defaults to
 * `client` (full viewport-height track). Pass a shorter `trackLength` when the vertical track is
 * shorter than the viewport (e.g. a reduced-height scrollbar track).
 */
function computeScrollSize(scroll, client, jog, trackLength = client) {
    // Track length must be <= client size.
    const trackSize = Math.min(trackLength, client);
    return scroll <= client ? 0 : Math.max(MIN_SIZE, (client / scroll) * (trackSize - jog));
}
/**
 * Get a tuple of the starting scroll %, and the new scroll amount (if applicable).
 * The new scroll amount will be null if the scrollbar thumb was clicked. Otherwise it will
 * be a value that causes the thumb to be centered under the pointer.
 */
function handleDragStart(both, 
// e.clientY
clientPos, 
// box.top
start, 
// box.height
size, 
// scrollEl.scrollHeight
scrollSize, 
// scrollEl.scrollTop
scrollAmount, 
// scrollEl.clientHeight
clientSize, 
// scrollSizeY
scrollBarSize, 
/** Shorter track centered in scrollEl. */
trackSize = clientSize) {
    // Ratio of bounding box to client box, for handling transform scale.
    // I doubt we'll encounter a need for this anywhere but with the storybook zoom controls.
    const scale = size / clientSize;
    const trackInsetTop = (clientSize - trackSize) / 2;
    const availableSize = trackSize - scrollBarSize - (both ? TRACK_SIZE : 0);
    const availableScroll = scrollSize - clientSize;
    const scrollPercent = scrollAmount / availableScroll;
    const mouseStart = clientPos - start - trackInsetTop;
    const scrollBarStart = availableSize * scale * scrollPercent;
    const scrollBarEnd = scrollBarStart + scrollBarSize * scale;
    const mouseOnScrollBar = mouseStart >= scrollBarStart && mouseStart <= scrollBarEnd;
    let newScroll = null;
    if (!mouseOnScrollBar) {
        // jump the scrollbar to the position it would be at if the midpoint of the scrollbar
        // mouse point - half scrollbar height == where we want the top to be. this is the percentage
        // of the scroll area minus the height of the bar
        const newStart = mouseStart - (scrollBarSize * scale) / 2;
        const newPercent = newStart / scale / availableSize;
        newScroll = newPercent * availableScroll;
    }
    const startPercent = (newScroll ?? scrollAmount) / availableScroll;
    return [startPercent, newScroll];
}
function handleDrag(both, 
// box.height
size, scrollBarSize, 
// scrollEl.scrollHeight
scrollSize, 
// scrollEl.clientHeight
clientSize, 
// e.delta.y
delta, 
// startPercent.current
startPercent, 
/** When the track is shorter than the scrollEl, its length in px. */
trackSize = clientSize) {
    const scale = size / clientSize;
    const availableHeight = trackSize - scrollBarSize - (both ? TRACK_SIZE : 0);
    const availableScroll = scrollSize - clientSize;
    const deltaPercent = delta / (availableHeight * scale);
    const newPercent = startPercent + deltaPercent;
    return newPercent * availableScroll;
}

export { computeScrollPosition, computeScrollSize, handleDrag, handleDragStart };
//# sourceMappingURL=scroll-container.utils.js.map
